export default "__VITE_ASSET__ateYgyt___"